import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useMap } from "react-map-gl";
import { useMapStore } from "../..";
import ILayerProps from "../../interfaces/IlayerProps";
import { minZoom } from "../mapConfig";

function IosZoningMapLayer({ visible }: ILayerProps) {
    const map = useMap().current!;
    const mapStore = useMapStore();

    useEffect(() => {
        if (!mapStore.isStyleLoaded)
            return;

        map.getStyle()!.layers
            .filter((l: any) => l.metadata && l.metadata["mapbox:group"] === "0adfb28b8775131812f91176c9808dcc")
            .forEach(l => {
                map.getMap().setLayerZoomRange(l.id, minZoom.iosZoning, map.getMap().getLayer(l.id)!.maxzoom!);
                map.getMap().setPaintProperty(l.id, "fill-opacity", visible ? [
                    'interpolate',
                    ['exponential', 0.5],
                    ['zoom'],
                    14, 1,
                    16, 0.2,
                    18, 0,
                ] : 0);
            });
    }, [mapStore.isStyleLoaded, visible]);

    return (
        <></>
    );
}

export default observer(IosZoningMapLayer);